/* eslint-disable */

import RaindropInput from "../raindrop-input/raindrop-input.tsx";
import ModelTag from "../model-tag/model-tag";
import Currency from "../currency/currency.tsx";
import ModelComponent from "../model-component/model-component.tsx";
import { useState } from "react";
import RaindropButton, {
  ButtonStyle,
} from "../raindrop-button/raindrop-button.tsx";
import { fetchGraphQL } from "../../services/api-raindrop.js";
import JSONBlob from "../json-blob/json-blob.tsx";

const OrganisationTransferActionPanel = ({ setIsEditing }) => {
  return (
    <div className={`flex flex-col`}>
      <RaindropButton
        onClick={() => setIsEditing(true)}
        style={ButtonStyle.Secondary}
        title={"Edit"}
        icon="fa-edit"
      />
    </div>
  );
};

const ModelComponentOrganisationTransfer = ({
  id,
  subunits,
  subunitsCurrency,
  transferred_at,
  stripe_transfer_id,
  stripePayoutId,
  status,
  rawData,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [newStripePayoutId, setNewStripePayoutId] = useState(stripePayoutId);
  const [newStatus, setNewStatus] = useState(
    status ?? "ORGANISATION_TRANSFER_STATUS__PENDING"
  );

  const onUpdateStatus = (newStatus) => {
    setIsSubmitting(true);

    fetchGraphQL(`
        mutation {
          organisationTransferUpdate(
            organisationTransferId: "${id}"
            status: "${newStatus}"
          ){
            status
          }
        }`)
      .then((resp) => {
        console.log("(RD-2343)", resp);
        setIsEditing(false);
        setIsSubmitting(false);
        setNewStatus(resp.data.organisationTransferUpdate.status);
      })
      .catch((error) => {
        setIsSubmitting(false);
        console.log(error);
      });
  };

  const onSubmit = () => {
    setIsSubmitting(true);

    fetchGraphQL(`
        mutation {
          organisationTransferUpdate(
            organisationTransferId: "${id}"
            stripePayoutId: "${newStripePayoutId}"
            
          ){
            
            stripePayoutId
            
          }
        }`)
      .then((resp) => {
        console.log("(RD-2343)", resp);
        setIsEditing(false);
        setIsSubmitting(false);
        setNewStripePayoutId(
          resp.data.organisationTransferUpdate.stripePayoutId
        );
      })
      .catch((error) => {
        setIsSubmitting(false);
        console.log(error);
      });
  };

  return (
    <ModelComponent
      modelId={id}
      colorBorderAccent="dark:border-l-color-dark-model-organisation border-l-color-model-organisation"
      dropdownComponent={
        <OrganisationTransferActionPanel setIsEditing={setIsEditing} />
      }
      rawData={rawData}
    >
      <div className="flex flex-col gap-1 w-full text-left">
        <div className="text-xs text-color-dark-text-tertiary">Amount</div>
        <Currency
          subunits={subunits}
          subunitsCurrency={subunitsCurrency}
          isCopyable={true}
        />
      </div>

      <RaindropInput
        label="Status"
        value={newStatus}
        isEditing={isEditing}
        isPopulatingExampleIfLocal={false}
        isShowLabel={true}
        icon=""
      />

      <RaindropInput
        label="Transferred At"
        value={transferred_at}
        isEditing={false}
        isPopulatingExampleIfLocal={false}
        isShowLabel={true}
        icon=""
      />

      <RaindropInput
        label="Stripe Transfer ID"
        value={stripe_transfer_id}
        isEditing={false}
        isPopulatingExampleIfLocal={false}
        isShowLabel={true}
        icon=""
      />

      <RaindropInput
        label="Stripe Payout ID"
        value={newStripePayoutId}
        onChange={(e) => setNewStripePayoutId(e.target.value)}
        isEditing={isEditing}
        isPopulatingExampleIfLocal={false}
        isShowLabel={true}
        icon=""
      />
      <div className="flex flex-row gap-2 overflow-scroll">
        <RaindropButton
          onClick={() => {
            onUpdateStatus("ORGANISATION_TRANSFER_STATUS__COMPLETED");
          }}
          style={ButtonStyle.Secondary}
          title={"Set COMPLETED"}
        />
        <RaindropButton
          onClick={() => {
            onUpdateStatus("ORGANISATION_TRANSFER_STATUS__IN_TRANSIT");
          }}
          style={ButtonStyle.Secondary}
          title={"Set IN_TRANSIT"}
        />
        <RaindropButton
          onClick={() => {
            onUpdateStatus("ORGANISATION_TRANSFER_STATUS__PENDING");
          }}
          style={ButtonStyle.Secondary}
          title={"Set PENDING"}
        />
      </div>

      {isEditing && (
        <div className="flex flex-row w-full">
          <RaindropButton
            onClick={() => {
              setIsEditing(false);
              setNewStripePayoutId(stripePayoutId);
            }}
            style={ButtonStyle.Secondary}
            title={"Cancel"}
            icon="fa-times"
          />
          <RaindropButton
            onClick={onSubmit}
            style={ButtonStyle.Primary}
            title={"Save"}
            icon="fa-save"
            isLoading={isSubmitting}
          />
        </div>
      )}
    </ModelComponent>
  );
};

export default ModelComponentOrganisationTransfer;
